import React from 'react'
import {connect} from 'react-redux'
import {is, fromJS} from 'immutable'

import {
  MESSAGE_TYPES
} from '../config/constants'

const {ADVERTISEMENT_BOT} = MESSAGE_TYPES

import {watchModeratedMessages, unwatchModeratedMessages} from '../data/watchers/moderated_messages'
import filterNotApprovedMessages from '../data/helpers/filter_not_approved_messages'
import filterHiddenAdvertisementCandidates from '../data/helpers/filter_hidden_advertisement_candidates'
import batchMessages from '../data/helpers/batch_messages'

import MessagesBatch from './messages_batch'
import MessagesAdvertisementBatch from './messages_advertisement_batch'

class MessagesList extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      messages: fromJS([])
    }

    this.renderMessagesBatch = this.renderMessagesBatch.bind(this)
  }

  componentWillMount () {
    if (this.props.messages && this.props.messages.size > 0) {
      this.updateMessages(this.props.messages)
    }

    if (this.props.messageType === MESSAGE_TYPES.MODERATED_GROUP) {
      this.props.watchModeratedMessages(this.props.containerId)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.messageType && this.props.messageType === MESSAGE_TYPES.MODERATED_GROUP) {
      this.moderatedListWillReceiveProps(nextProps)
    }
    else {
      this.listWillReceiveProps(nextProps)
    }
  }

  componentWillUnmount () {
    if (this.props.messageType === MESSAGE_TYPES.MODERATED_GROUP) {
      this.props.unwatchModeratedMessages(this.props.containerId)
    }
  }

  moderatedListWillReceiveProps (nextProps) {
    const shouldUpdateMessages = (
      !is(this.props.currentUser, nextProps.currentUser) ||
      !is(this.props.messages, nextProps.messages) ||
      !is(this.props.isAdvEnabledForModeratedChat, nextProps.isAdvEnabledForModeratedChat)
    )

    if (shouldUpdateMessages) {
      const uid = this.props.currentUser.get('uid')
      const role = this.props.currentUser.get('role')

      let messages = filterNotApprovedMessages(nextProps.messages, uid, role)
      messages = filterHiddenAdvertisementCandidates(nextProps.messages, nextProps.groupChat, nextProps.isAdvEnabledForModeratedChat)

      this.updateMessages(messages)
    }
  }

  listWillReceiveProps (nextProps) {
    const shouldUpdateMessages = (
      !is(this.props.messages, nextProps.messages)
    )

    if(shouldUpdateMessages) this.updateMessages(nextProps.messages)
  }

  updateMessages (nextMessages) {
    const messages = batchMessages(nextMessages)
    this.setState({messages})
  }

  renderMessagesBatch (batch, key) {
    if (batch.get('type') === ADVERTISEMENT_BOT) {
      return (
        <MessagesAdvertisementBatch
          key={key}
          batch={batch}
          containerId={this.props.containerId}
          maxBubbleWidth={this.props.maxBubbleWidth}
          messageType={batch.get('type')}/>
      )
    }
    else {
      return (
        <MessagesBatch
          key={key}
          batch={batch}
          containerId={this.props.containerId}
          messageType={this.props.messageType}
          maxBubbleWidth={this.props.maxBubbleWidth}
          onMessageItemHeightChange={this.props.onMessageItemHeightChange}
          isRichMessageContentEnabled={this.props.isRichMessageContentEnabled}/>
      )
    }
  }

  renderMessages () {
    let conversationContent = []

    if (this.props.contentMessage) {
      conversationContent.push(this.props.contentMessage)
    }

    if (this.props.messages) {
      const messagesList = this.state.messages
        .map(this.renderMessagesBatch)
        .toArray()

      conversationContent = conversationContent.concat(messagesList)
    }

    return conversationContent
  }


  render () {
    return (
      <div className='messages-list-container'>
        <div ref='messagesList' className='messages-list'>
          {this.renderMessages()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.get('currentUser', fromJS({})),
    groupChat: state.getIn(['groups', 'all', ownProps.containerId]),
    isAdvEnabledForModeratedChat: state.getIn(['advertisements', 'settings', 'isModeratedGroupChatEnabled'])
  }
}

const mapDispatchToProps = () => {
  return {
    watchModeratedMessages: watchModeratedMessages,
    unwatchModeratedMessages: unwatchModeratedMessages
  }
}

const MessagesListContainer = connect(
  mapStateToProps, mapDispatchToProps
)(MessagesList)

export default MessagesListContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/conversation/messages_list.js
 **/